<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="login">
    <v-row class="max-w">
      <v-col cols="12">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="mx-4"
        >
          <!--<div class="headline font-weight-medium mb-6 text-center">
            {{ $t('boilerTemp') }}
          </div>-->

          <div class="subtitle-1 font-weight-medium mb-4 text-center c-set">
            {{ $t('temp-zadana') }}
          </div>

          <div class="d-flex justify-space-between align-center">
            <div>
              <v-btn class="ma-2" fab color="red" @click="cwTempSetting--">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </div>
            <div class="display-1 c-set">
              {{ cwTempSetting }} &deg;C
            </div>
            <div>
              <v-btn class="ma-2" fab color="red" @click="cwTempSetting++">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

          <div class="my-3 px-7">
            <v-slider
              v-model="cwTempSetting"
              color="red"
              :min="cwTempMin"
              :max="cwTempMax"
            >
              <template v-slot:prepend>
                {{ cwTempMin }}
              </template>
              <template v-slot:append>
                {{ cwTempMax }}
              </template>
            </v-slider>
          </div>

          <template v-if="cwTempReducedSetting">
            <div class="subtitle-1 font-weight-medium mb-4 text-center c-low">
              {{ $t('temp-obn') }}
            </div>

            <div class="d-flex justify-space-between align-center">
              <div>
                <v-btn class="ma-2" fab color="primary" @click="cwTempReducedSetting--">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </div>
              <div class="display-1 c-low">
                {{ cwTempReducedSetting }} &deg;C
              </div>
              <div>
                <v-btn class="ma-2" fab color="primary" @click="cwTempReducedSetting++">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>

            <div class="my-3 px-7">
              <v-slider
                v-model="cwTempReducedSetting"
                color="primary"
                :min="cwTempReducedMin"
                :max="cwTempReducedMax"
              >
                <template v-slot:prepend>
                  {{ cwTempReducedMin }}
                </template>
                <template v-slot:append>
                  {{ cwTempReducedMax }}
                </template>
              </v-slider>
            </div>
          </template>

          <div class="d-flex t-primary justify-center" :class="(cwTempReducedSetting) ? 'mt-5' : 'mt-8'">
            <v-btn 
              :loading="saving"
              :disabled="saving" 
              @click="postForm"
              x-large 
              class="mx-1" 
              color="primary"
              >{{ $t('zapisz') }}</v-btn>
            <v-btn x-large text class="mx-1" @click="$router.go(-1)">{{ $t('anuluj') }}</v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  data: () => ({
    valid: true,
    cwTempSetting: 0,
    cwTempReducedSetting: null
  }),
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    params () {
      return this.$store.state[this.moduleName].params
    },
    cwTempMin() {
      return this.$store.state[this.moduleName].cwTempMin
    },
    cwTempMax() {
      return this.$store.state[this.moduleName].cwTempMax
    },
    cwTempReducedMin() {
      return this.$store.state[this.moduleName].cwTempReducedMin
    },
    cwTempReducedMax() {
      return this.$store.state[this.moduleName].cwTempReducedMax
    },
    saving() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].saving
      } else {
        return true
      }
    }
  },
  created () {
    //przekieruj na dashboard jesli wejscie bezposrednie, a moze lepiej zarejestrowac modul i zsynchronizowac dane?
    if (!(this.$store && this.$store.state && this.$store.state[this.moduleName])) {
      this.$router.push({ path: '/dashboard/' + this.controllerId });
    } else {
      this.cwTempSetting = parseInt(this.params.cwTempSet);
      this.cwTempReducedSetting = parseInt(this.params.cwTempReduced);
      
    }
  },
  methods: {
    validate () {
    },
    postForm () {
      this.$store.dispatch(`${this.moduleName}/setCwTemp`, { 
        tempSet: this.cwTempSetting, 
      }).then(res => {
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
        } else {
          this.$store.commit("alert", {
            color: "success",
            timeout: 900,
            ok: true,
            text: 'OK'
          });
          this.$router.push({ path: '/dashboard/' + this.controllerId });
        }
      });
    }
  },
}
</script>

<style>

</style>

